import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { UtilService } from './shared/util.service';
import { Router } from '@angular/router';
import { Location, isPlatformBrowser, DOCUMENT } from '@angular/common';
import { VersionCheckService } from './_services/index';
import { Title, Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    providers: [],
    standalone: false
})
export class AppComponent implements OnInit {
  currentPath: string = '';
  private isBrowser: boolean;

  constructor(
    private versionCheckService: VersionCheckService,
    private utilService: UtilService,
    private router: Router,
    private location: Location,
    private meta: Meta,
    private titleService: Title,
    private translate: TranslateService,
    // BORRADO: private gtmService: GoogleTagManagerService,
    @Inject(PLATFORM_ID) platformId: Object, // Inyectamos ID de plataforma
    @Inject(DOCUMENT) private document: Document
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    this.router.events.subscribe(() => {
      this.currentPath = this.location.path();
      this.setTitle();
    });

    this.utilService.isLanguageChanged().subscribe(() => {
      this.setTitle();
    });

  }

  ngOnInit() {
    if (!this.utilService.isLocal()) {
      this.versionCheckService.initVersionCheck('version.json');
    }
    this.handleLocalRedirect();
  }

  setTitle() {
    if (this.utilService.currentLanguage && this.currentPath.includes('/login')) {
      this.translate
        .get(['themes.public.title_page', 'themes.meta_tags.description.content'])
        .subscribe((res: any) => {
          this.meta.addTag({ name: 'description', content: res['themes.meta_tags.description.content'] });
          this.titleService.setTitle(res['themes.public.title_page']);
        });
    } else if (this.utilService.currentLanguage && this.currentPath.includes('/collect/portal')) {
      this.translate.get(['themes.public.title_collect_portal']).subscribe((res: any) => {
        this.titleService.setTitle(res['themes.public.title_collect_portal']);
      });
    } else {
      this.titleService.setTitle('myHotel Fidelity Suite');
    }
  }

  private handleLocalRedirect(): void {
    // Protección: window solo existe en el navegador
    if (!this.isBrowser) return;

    const currentUrl = window.location.href;
    const surveyRegex = /\/survey-public\/survey\/(.*)/;
    const match = surveyRegex.exec(currentUrl);

    if (match) {
      const surveyIdAndParams = match[1];
      const subDomain = environment.envName === 'development' ? 'surveys-dev' : 'surveys';
      const domain = 'myhotel.cl';

      const newUrl = `https://${subDomain}.${domain}/survey-public/survey/${surveyIdAndParams}`;
      window.location.replace(newUrl);
    }
  }
}